module.exports = __webpack_public_path__ + "84513624e0f6c8fb129e9462d58f8ea2.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/818.png
// module id = 1721
// module chunks = 2